import React, { FunctionComponent } from 'react';

type Props = {
  logoPc: string;
  logoSp: string;
  headerLogoClassName: string;
};

export const Presentation: FunctionComponent<Props> = ({
  logoPc,
  logoSp,
  headerLogoClassName
}) => {
  return (
    <div className={headerLogoClassName}>
      <a className="l-header-logo-link pc-logo" href="/">
        <img src={logoPc} className="l-header-logo-img" alt="READY TO FASHION" width={244} />
      </a>
      <a className="l-header-logo-link sp-logo" href="/">
        <img src={logoSp} className="l-header-logo-img" alt="READY TO FASHION" width={244} />
      </a>
    </div>
  );
};
